// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      :host {
        display: block;
        height: 100%;
      }
      .ps-shim {
        display: block;
        height: 100%;
      }
    `, "",{"version":3,"sources":["webpack://./src/app/sharedmodule/perfect-scrollbar-shim/perfect-scrollbar-shim.component.ts"],"names":[],"mappings":";MACM;QACE,cAAc;QACd,YAAY;MACd;MACA;QACE,cAAc;QACd,YAAY;MACd","sourcesContent":["\n      :host {\n        display: block;\n        height: 100%;\n      }\n      .ps-shim {\n        display: block;\n        height: 100%;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
